__turbopack_context__.v({
  "ul": "styles-module__PwzZdG__ul",
});
